let timer = null;
class Tab {
  constructor(selector, options) {
    this.selector = selector;
    this.elements = document.querySelectorAll(selector);
    this.url = new URL(document.location.href);
    this.params = {
      onChange: () => {
        console.log('tab change');
      },
      ...options,
    };
    this.#init();
    // this.#hash();
  }
  #init() {
    this.#event();
  }
  #activeTab(tabID, panelIndex) {
    const _this = this;
    const tabLinks = document.querySelectorAll(`[data-tab="${tabID}"]`);
    const tabContent = document.querySelector(`.tab-content[tab-id="${tabID}"]`);
    const tabBlock = tabContent.closest('.tab-block');
    const tabPanels = tabContent.querySelectorAll('.tab-panel');
    const targetPanel = tabPanels[panelIndex];
    const searchParams = new URLSearchParams(`tab=${tabID}-${panelIndex + 1}`);
    if (timer) {
      clearTimeout(timer);
    }
    tabLinks.forEach(element => {
      element.classList.remove('active');
    });
    tabBlock.querySelectorAll('.tab-nav').forEach(element => {
      const targetLink = element.querySelectorAll(_this.selector);
      targetLink[panelIndex].classList.add('active');
    });
    tabPanels.forEach(element => {
      element.classList.remove('active');
    });
    targetPanel.classList.add('active');

    // this.url.search = searchParams;
    // history.replaceState(null, '', this.url.href);

    timer = setTimeout(() => {
      this.params.onChange(tabID, panelIndex);
    }, 100);
  }
  #event() {
    const _this = this;
    const triggerTab = e => {
      const target = e.target.closest(_this.selector);
      const tabNav = e.target.closest('.tab-nav');
      const siblingsTabLink = tabNav.querySelectorAll(_this.selector);
      const targetIndex = [...siblingsTabLink].indexOf(target);
      const tabID = target.getAttribute('data-tab');
      this.#activeTab(tabID, targetIndex);
    };
    _this.elements.forEach(element => {
      element.addEventListener('click', triggerTab);
    });
  }
  #hash() {
    const searchParams = this.url.searchParams;
    if (searchParams.size === 0 || searchParams.toString().includes('tab=') === false) return;
    const target = searchParams.toString().replace('tab=', '').split('-');
    const tabID = target[0];
    const allChildPanels = document.querySelector(`[tab-id="${tabID}"]`)?.querySelectorAll('.tab-panel');
    const tabPanel = allChildPanels[target[1] - 1];
    const panelIndex = [...allChildPanels].indexOf(tabPanel);
    const tabHeadline = document.querySelector(`.tab-block.${tabID} .tab-headline`);
    const tabHeadlineOffsetTop = tabHeadline.offsetTop;
    this.#activeTab(tabID, panelIndex);
    setTimeout(() => {
      window.scrollTo({
        top: tabHeadlineOffsetTop,
      });
    }, 500);
  }
}

export default Tab;
